import React from 'react';
import Hero from '../components/Hero';
import WhoWeAre from '../components/WhoWeAre';
import ReviewsBar from '../components/ReviewsBar';
import OnlineCourses from '../components/OnlineCourses';
import FreeAssessment from '../components/FreeAssessment';
import WhyChooseUs from '../components/WhyChooseUs';
import ParallaxSections from '../components/ParallaxSections';
import AboutFeatures from '../components/AboutFeatures';
import Testimonials from '../components/Testimonials';
import AdultsAndJourney from '../components/AdultsAndJourney';
import CertifiedTutors from '../components/CertifiedTutors';
import PricingAndStates from '../components/PricingAndStates';
import AdditionalBenefits from '../components/AdditionalBenefits';
import FAQSection from '../components/FAQSection';
import ConsultationSection from '../components/ConsultationSection';
import HomeBlogs from '../components/HomeBlogs';
import './Home.css';

const Home = () => {
  return (
    <div className="home-page" id="home">
      <Hero />
      <WhoWeAre />
      <ReviewsBar />
      <OnlineCourses />
      <FreeAssessment />
      <WhyChooseUs />
      <ParallaxSections />
      <AboutFeatures />
      <Testimonials />
      <AdultsAndJourney />
      <CertifiedTutors />
      <PricingAndStates />
      <AdditionalBenefits />
      <FAQSection />
      <ConsultationSection />
      <HomeBlogs />
    </div>
  );
};

export default Home;


